import { BsTrash, BsEnvelope, BsGlobe } from 'react-icons/bs';

import EnumFilterControl from '#globalComponents/Table/filters/EnumFilterControl';
import HeaderFilter from '#globalComponents/Table/filters/HeaderFilter';
import { ROW_ACTION_BUTTON } from '#globalComponents/Table/tableStyles';
import { formatDate } from '#lib/dateUtils';

import { BLACKLIST_ENTRY_TYPE_OPTIONS } from '../../constants/tableFilters';

const SOURCE_LABELS = {
	manual: 'Manuell',
	unsubscribe: 'Abmeldung',
	import: 'Import',
};

/**
 * Column config of the contact blacklist table.
 *
 * @param {Object} params
 * @param {Object} params.filters - Active filters (entryType)
 * @param {Function} params.onFilterChange - Receives a partial filter object
 * @param {(entry: Object) => void} params.onDelete
 * @returns {Array<Object>}
 */
export function buildBlacklistColumns({ filters, onFilterChange, onDelete }) {
	return [
		{
			key: 'value',
			label: 'Wert',
			render: (entry) => <span className="font-semibold text-text">{entry.value}</span>,
		},
		{
			key: 'entryType',
			label: 'Typ',
			headerAccessory: (
				<HeaderFilter label="Typ filtern" active={Boolean(filters.entryType)}>
					<EnumFilterControl
						paramKey="entryType"
						options={BLACKLIST_ENTRY_TYPE_OPTIONS}
						value={filters.entryType}
						onChange={onFilterChange}
					/>
				</HeaderFilter>
			),
			render: (entry) => (
				<span className="inline-flex items-center gap-1.5">
					{entry.entryType === 'email' ? (
						<BsEnvelope className="w-3 h-3 text-bgBase-800" />
					) : (
						<BsGlobe className="w-3 h-3 text-bgBase-800" />
					)}
					{entry.entryType === 'email' ? 'E-Mail' : 'Domain'}
				</span>
			),
		},
		{
			key: 'reason',
			label: 'Grund',
			render: (entry) => <span className="text-bgBase-800">{entry.reason || '—'}</span>,
		},
		{
			key: 'source',
			label: 'Quelle',
			render: (entry) => <span className="text-bgBase-800">{SOURCE_LABELS[entry.source] ?? entry.source}</span>,
		},
		{
			key: 'createdAt',
			label: 'Hinzugefügt',
			render: (entry) => <span className="text-bgBase-800">{formatDate(entry.createdAt)}</span>,
		},
		{
			key: 'actions',
			align: 'right',
			width: 64,
			render: (entry) => (
				<button onClick={() => onDelete(entry)} className={ROW_ACTION_BUTTON} title="Entfernen">
					<BsTrash />
				</button>
			),
		},
	];
}
